import siteConfigService from '@/services/site.config.service';
import Logger from '@/utils/logger.utils';
import WindowUtils from '@/utils/window-utils';
import { storageService } from '@ol/ol-ui-core';
import axios from 'axios';

class ErrorHandlerService {
  private defaultLogoutUrl: string = '/stdpl/logout.html';

  public setupInterceptors(): void {
    axios.interceptors.response.use(response => response, async (error) => {
      Logger.info(`error---> ${JSON.stringify(error)}`);
      await this.dispatchError(error);
      throw error;
    });
  }

  public async dispatchError(error: any): Promise<void> {
    if (error.response) {
      const response: any = error.response;
      if (response.status === 401) {
        await this.handle401Error(error);
      }
    }
  }

  public async handle401Error(error: any): Promise<void> {
    Logger.info('API Called Failed Eith 401 Error Code, Logout User');
    let apiEndpoint: string = await siteConfigService.getApiEndpoint('logoutUrl');
    if (!apiEndpoint || apiEndpoint === '') {
      apiEndpoint = this.defaultLogoutUrl;
    }
    await storageService.cleanStorageAfterLogout();
    WindowUtils.setLocationHref(this.defaultLogoutUrl);
  }
}

// Export a singleton instance in the global namespace
const errorHandlerService: ErrorHandlerService = new ErrorHandlerService();
export default errorHandlerService;
